// supabaseClient.js
import { createClient } from '@supabase/supabase-js';
import axios from 'axios';

const API_URL = 'https://us-central1-tikcare-d0cb9.cloudfunctions.net';

// Replace with your Supabase URL and anon key
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
export const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Second Supabase project (health-intent): the new WhatsApp triage bot's database.
// Used only by the Chats tab to read/write the wa_messages inbox. This client is
// anon-only (the scribe app never authenticates against this project), so we disable
// session persistence to keep it fully isolated from the main client's auth/localStorage.
export const healthIntentSupabaseUrl = process.env.REACT_APP_HEALTH_INTENT_SUPABASE_URL;
export const healthIntentSupabaseAnonKey = process.env.REACT_APP_HEALTH_INTENT_SUPABASE_ANON_KEY;

export const supabaseHealthIntent = createClient(healthIntentSupabaseUrl, healthIntentSupabaseAnonKey, {
  auth: { persistSession: false, autoRefreshToken: false },
});

export const TikcareAssistantService = axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
    //   'Access-Control-Allow-Origin': '*',
    },
});